module.exports = __webpack_public_path__ + "static/recruit-lifestyle-91d665be31d68e88d2399722a84a8169.svg";